import translate from './Translate.js'

class ErrorFn {
  constructor () {
    this.errorTip = {
      EMPTY_PASSWORD: translate('Sorry, the password you inputted is empty.'),
      EMPTY_ACCOUNT: translate('Sorry, the input is empty.'),
      EMPTY_NAME: translate('Sorry, the name you inputted is empty.'),
      EMPTY_CODE: translate('Sorry, the code you inputted is empty.'),
      INVALID_PHONE: translate('Sorry, the phone number you inputted is invalid.'),
      INVALID_USERNAME_1: translate('The username need to start with a letter and comprise 6-20 characters.'),
      INVALID_USERNAME_2: translate('The username only support two special characters: - and _'),
      INVALID_PASSWORD: translate('The password needs to have more than 6 letters')
    }
  }
  openErrorTip (msg, that) {
    if (this.errorTip[msg]) {
      that.errorMsg = this.errorTip[msg]
    } else {
      that.errorMsg = msg
    }
    that.errorShow = true
  }
  closeErrorTip (that) {
    that.errorMsg = ''
    that.errorShow = false
  }
}
export const errorFn = new ErrorFn()



// WEBPACK FOOTER //
// ./src/new-login-2018/common/ErrorMsg.js